
import { SnackbarProgrammatic as Snackbar } from 'buefy'
import API from '@/api'

import {
  downloadBase64File
} from '@/utils/helpers'

const actions = {
  getSuppliers({ commit }) {
    API.payment.getSuppliers()
      .then(({ data: { data: { paymentSuppliers, cardCommission } } }) => {
        commit('setMethodSelectForm', {
          paymentSuppliers,
          cardCommission
        })
      })
      .catch(() => {
        commit('setMethodSelectForm', {
          hasError: true
        })
      })
      .finally(() => {
        commit('setMethodSelectForm', {
          isLoading: false
        })
      })
  },
  getBillingData({ commit }, payload) {
    API.payment.getDetails(payload)
      .then(({ data: { data } }) => {
        commit('setBillingData', data)
      })
      .catch(() => {
        commit('setBillingData', {
          hasError: true
        })
      })
      .finally(() => {
        commit('setBillingData', {
          isLoading: false
        })
      })
  },
  getBillingLink({ commit }, payload) {
    API.payment.getLink(payload)
      .then(({ data: { data: { url } } }) => {
        window.location.href = url
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Не удалось получить ссылку для оплаты.',
          type: 'is-danger',
          position: 'is-top-right',
          actionText: 'Ок'
        })
      })
      .finally(() => {
        commit('setBillingForm', {
          isLoading: false
        })
      })
  },
  getInvoice({ commit }, { orderId, ...params }) {
    API.payment.getInvoice(orderId, params)
      .then(({ data: { data: { blank } } }) => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Успешно</span>Файл с инструкцией скачивается',
          type: 'is-success',
          position: 'is-top-right',
          actionText: 'Ок'
        })

        downloadBase64File(blank, `Оплата заказа №${orderId}.pdf`)
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Не удалось скачать инструкцию.',
          type: 'is-danger',
          position: 'is-top-right',
          actionText: 'Ок'
        })
      })
      .finally(() => {
        commit('setInvoiceForm', {
          isLoading: false,
          supplierCode: null
        })

        commit('setMethodSelectForm', {
          isActive: false
        })
      })
  }
}

export default actions